import { Section } from '@/components/layout/Section';

const reviews = [
  {
    title: 'Business Growth Project', service: 'Web Development & SEO',
    quote: 'Falcon Solutions delivered a high-quality website and complete SEO strategy for our business. Their team was professional, responsive, and easy to work with. They understood our goals, provided valuable recommendations, and delivered everything on time. The results have significantly improved our online visibility and lead generation. Highly recommend them for web development and digital marketing services.',
  },
  {
    title: 'AI Product Development', service: 'SaaS Product (NDA)',
    quote: 'Falcon Solutions delivered an outstanding AI solution for our business. Their team understood our requirements, provided valuable technical recommendations, and delivered the product on time. They were highly responsive, professional, and easy to work with throughout the project. The final solution has significantly improved our workflow and efficiency. Highly recommended for AI development and integration services.',
  },
];

export function Testimonials() {
  return <Section>
    <div id="testimonials" className="scroll-mt-28">
      <p className="text-eyebrow text-brand">Testimonials</p>
      <h2 className="text-display-md mt-4">Feedback on delivered work</h2>
      <p className="mt-5 max-w-[65ch] text-ink/70">The feedback below is shared without reviewer names. The AI product engagement is covered by an NDA.</p>
      <div className="mt-10 space-y-6">
        {reviews.map(review => <figure key={review.title} className="testimonial-card">
          <figcaption className="testimonial-meta">
            <p className="text-sm text-ink/60">Client review</p>
            <h3 className="mt-4 font-display text-xl font-bold">{review.title}</h3>
            <p className="mt-2 text-sm text-ink/70">{review.service}</p>

          </figcaption>
          <blockquote className="testimonial-quote">
            <span className="testimonial-quote-mark" aria-hidden="true">“</span>
            <p>{review.quote}</p>
          </blockquote>
        </figure>)}
      </div>
    </div>
  </Section>;
}
